import React from "react";
import ListSettingsStore from "./ListSettingsStore";
import Language from "../lib/Language";
import TemplateKind, { Kind } from "../models/TemplateKind";
import RC from "../lib/ReservationConstants";
import _ from "underscore";

// class Help
type TReservationListSettingsProps = {
    allReservations: boolean;
    includeMembers: number;
    templateKind: Kind;
    reservationStatus: number[];
    reservationVariant: number;
    complete: boolean;
    incomplete: boolean;
    useTemplateGroup: boolean;
    isAdmin: boolean;
    onChange: (settings: TReservationListSettingsState, callback?: () => void) => void;
    saveDefaultSettings: () => void;
    saveSettings: (...args: any[]) => void;
    removeSettings: (...args: any[]) => void;
    getSavedSettings: (callback: (result: any[]) => void) => void;
};

type TReservationListSettingsState = {
    allReservations: boolean;
    includeMembers: number;
    templateKind: Kind;
};

class ReservationListSettings extends React.Component<
    TReservationListSettingsProps,
    TReservationListSettingsState
> {
    constructor(props) {
        super(props);

        this.state = this._getInitState(props);
    }

    _getInitState = (props: TReservationListSettingsProps) => {
        return {
            // Search options
            allReservations: props.allReservations,
            includeMembers: props.includeMembers,
            templateKind: props.templateKind,
        };
    };

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.state, prevState)) {
            const settings = _.clone(this.state);
            this.props.onChange(settings);
        }
    }

    onTemplateKindChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const stateChange = { templateKind: TemplateKind.get(parseInt(event.target.value, 10)) };
        this.setState(stateChange);
    };

    onMembersChanged = (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ includeMembers: parseInt(event.target.value, 10) });
    };

    onAllReservationsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ allReservations: !event.target.checked });
    };

    render() {
        return (
            <div>
                <h3 className="core-header">{Language.get("nc_list_search_settings_title")}</h3>

                <ListSettingsStore
                    searchSettings={this.state}
                    onChange={(search) => this.setState(search)}
                    getSavedSettings={this.props.getSavedSettings}
                    saveSettings={this.props.saveSettings}
                    removeSettings={this.props.removeSettings}
                    saveDefaultSettings={this.props.saveDefaultSettings}
                />

                <div className="settingsContainer">
                    <div className="settingsLine">
                        <label>{Language.get("dynamic_reserv_list_reservation_type")}</label>
                        <select
                            value={this.state.templateKind.number}
                            onChange={this.onTemplateKindChange}
                        >
                            <option value={TemplateKind.RESERVATION.number} key="bokning">
                                {Language.get("dynamic_reserv_list_reservation")}
                            </option>
                            <option value={TemplateKind.AVAILABILITY.number} key="tillgänglighet">
                                {Language.get("dynamic_reserv_list_availability")}
                            </option>
                            <option value={TemplateKind.INFO_RESERVATION.number} key="info">
                                {Language.get("dynamic_reserv_list_info")}
                            </option>
                        </select>
                    </div>
                    <hr />
                    <div className="settingsLine">
                        <div className="settingsLine">
                            <input
                                type="checkbox"
                                checked={!this.state.allReservations}
                                onChange={this.onAllReservationsChange}
                            />{" "}
                            {Language.get("nc_reserv_list_only_mine")}
                        </div>
                    </div>
                    <hr key="divider" />
                    <div className="settingsLine" key="settings">
                        <label>{Language.get("dynamic_reserv_list_members")}</label>
                        <select onChange={this.onMembersChanged} value={this.state.includeMembers}>
                            <option value={RC.MEMBERS.EXCLUDE} key="Exkludera">
                                {Language.get("dynamic_reserv_list_exclude")}
                            </option>
                            <option value={RC.MEMBERS.INCLUDE} key="Inkludera">
                                {Language.get("dynamic_reserv_list_include")}
                            </option>
                            <option value={RC.MEMBERS.OBSTACLES} key="Förhinder">
                                {Language.get("dynamic_reserv_list_obstacles")}
                            </option>
                            <option value={RC.MEMBERS.MEMBERS_ONLY} key="Endast medlemmar">
                                {Language.get("dynamic_reserv_list_members")}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReservationListSettings;
